import '/vercel/path0/node_modules/.pnpm/@etchteam+storybook-addon-status@4.2.4/node_modules/@etchteam/storybook-addon-status/register.js';